import { TemplateResult } from 'lit';

export interface SelectedOption {
  label: string;
  value: number | string;
  extraDetails?: any;
}

export interface ListItem {
  id?: string;
  label: string;
  value: number | string;
  disabled?: boolean;
  parent?: string;
  hidden?: boolean;
  // this is used to render custom HTML content in the list item
  itemSuffixRenderer?: (item: ListItem) => TemplateResult;
  extraDetails?: any;
}

export enum ListEvents {
  SELECTION_CHANGE = 'selectionChange',
  OPTIONS_FILTERED = 'optionsFiltered',
  SEARCH_INPUT_CHANGE = 'searchInputChange',
  SCROLL = 'listScroll',
}
